import React, { useState } from 'react'
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../../CONSTANTS";
import ProfilePersonalDetails from '../modals/ProfilePersonalDetails';

function ProfileWidgetPersonal({user }) {

  const [showModal, setShowModal]                                  = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="card shadow-sm h-100">
        {
          user && (
            <div className="card-body">
            <div className="row">
              <div className="col-md-4 mb-3">
                <strong>Name:</strong> <div>{user.name}</div>
              </div>
              <div className="col-md-4 mb-3">
                <strong>Surname:</strong> <div>{user.surname}</div>
              </div>
              <div className="col-md-4 mb-3">
                <strong>Date of Birth:</strong> <div>{user.dateOfBirth}</div>
              </div>
              <div className="col-md-4 mb-3">
                <strong>Email:</strong> <div>{user.email}</div>
              </div>
              <div className="col-md-4 mb-3">
                <strong>Phone:</strong> <div>{user.phone}</div>
              </div>
            </div>

            <button className="btn btn-outline-primary mt-3" onClick={handleOpenModal}>
              Update
            </button>

           <ProfilePersonalDetails show={showModal} onClose={handleCloseModal} user={user} />
        </div>
          )
        }
    </div>
  )
}

export default ProfileWidgetPersonal